import { supabase } from '@/integrations/supabase/client';
import type { SingleResult } from '@/lib/rpc/types';

export async function getUserSession(): Promise<SingleResult<{ user: { id: string; email?: string } | null }>> {
  try {
    // E2E Testing Bypass
    if (typeof window !== 'undefined' && window.localStorage.getItem('e2e_admin_bypass') === 'true') {
      const email = window.localStorage.getItem('e2e_user_email') || 'admin@test.com';
      return {
        ok: true,
        data: { 
          user: { 
            id: 'test-admin-user-id', 
            email 
          } 
        },
        source: 'single'
      };
    }

    // Use direct client method - no edge function needed for session
    const { data, error } = await supabase.auth.getSession();
    
    if (error) {
      return {
        ok: false,
        error: error.message || 'Failed to get user session',
        source: 'single'
      };
    }
    
    return {
      ok: true,
      data: { user: data?.session?.user ?? null },
      source: 'single'
    };
  } catch (error: any) {
    return {
      ok: false,
      error: error.message || 'Failed to get user session',
      source: 'single'
    };
  }
}

export async function authSignOut(): Promise<{ ok: boolean }> {
  try {
    // Use direct client method - no edge function needed for signout
    const { error } = await supabase.auth.signOut();
    return { ok: !error };
  } catch (error: any) {
    return { ok: false };
  }
}